import type { RevisionedLineItem } from '@weft/types';
import { REVISIONED_LINE_ITEM_TYPES } from '@weft/types';

export function filterFixedRevisionedLineItems(revisionedLineItems: RevisionedLineItem[]) {
  return revisionedLineItems.filter(isFixedRevisionedLineItem);
}

export function filterPromotionRevisionedLineItems(revisionedLineItems: RevisionedLineItem[]) {
  return revisionedLineItems.filter((revisionedLineItem) => isFixedPromotionRevisionedLineItem(revisionedLineItem) || isPercentagePromotionRevisionedLineItem(revisionedLineItem));
}

export function filterUsageRevisionedLineItems(revisionedLineItems: RevisionedLineItem[]) {
  return revisionedLineItems.filter(isUsageRevisionedLineItem);
}

export function isFixedRevisionedLineItem(revisionedLineItem: RevisionedLineItem): revisionedLineItem is ({ type: 'Fixed' } & RevisionedLineItem) {
  return revisionedLineItem.type === REVISIONED_LINE_ITEM_TYPES.Fixed;
}

export function isFixedPromotionRevisionedLineItem(revisionedLineItem: RevisionedLineItem): revisionedLineItem is ({ type: 'FixedPromotion' } & RevisionedLineItem) {
  return revisionedLineItem.type === REVISIONED_LINE_ITEM_TYPES.FixedPromotion;
}

export function isPercentagePromotionRevisionedLineItem(revisionedLineItem: RevisionedLineItem): revisionedLineItem is ({ type: 'PercentagePromotion' } & RevisionedLineItem) {
  return revisionedLineItem.type === REVISIONED_LINE_ITEM_TYPES.PercentagePromotion;
}

export function isUsageRevisionedLineItem(revisionedLineItem: RevisionedLineItem): revisionedLineItem is ({ type: 'Usage' } & RevisionedLineItem) {
  return revisionedLineItem.type === REVISIONED_LINE_ITEM_TYPES.Usage;
}